import { ChakraProvider, theme } from "@chakra-ui/react";
import { MsalProvider } from "@azure/msal-react";
import { Router } from "Router";
import pca from "helpers/msalInsatance";
import ErrorBoundary from "components/ErrorBoundary";

export const App = () => (
  <ChakraProvider theme={theme}>
    <ErrorBoundary>
      <MsalProvider instance={pca}>
        <Router />
      </MsalProvider>
    </ErrorBoundary>
  </ChakraProvider>
);
